import ROUTES from '../routes';
import CorporateClientsRisk from '../hoc/corporate-clients-risk/corporate-clients-risk';
import CorporateClientsIncorporateDatesList from '../hoc/corporate-clients-risk/incorporation-date/incorporation-dates';
import CorporateClientsIncorporateDatesForm from '../hoc/corporate-clients-risk/incorporation-date/form';
import CorporateClientsSicCodes from '../hoc/corporate-clients-risk/sic-codes/sic-codes';
import CorporateClientsGeographical from '../hoc/corporate-clients-risk/geographical';
import CorporateClientsVolumesList from '../hoc/corporate-clients-risk/volumes/volumes-list';
import CorporateClientsVolumesForm from '../hoc/corporate-clients-risk/volumes/volumes-form';
import CorporateClientsProductsList from '../hoc/corporate-clients-risk/products/products';
import CorporateClientsProductsForm from '../hoc/corporate-clients-risk/products/form';
import CorporateDeliveryChannelsList from '../hoc/corporate-clients-risk/delivery-channels/list';
import CorporateDeliverychannelsForm from '../hoc/corporate-clients-risk/delivery-channels/form';
import CorporateSicCodePanel from '../hoc/corporate-clients-risk/sic-codes/sic-code';

const CorporateClientsRiskRoutes = {
  path: ROUTES.CORPORATE_CLIENTS_RISK,
  element: <CorporateClientsRisk />,
  children: [
    {
      path: ROUTES.CORPORATE_CLIENTS_RISK_GEOGRAPHICAL,
      element: <CorporateClientsGeographical />,
    },
    {
      path: ROUTES.CORPORATE_CLIENTS_RISK_VOLUMES,
      element: <CorporateClientsVolumesList />,
      children: [
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_VOLUMES_CREATE,
          element: <CorporateClientsVolumesForm />,
        },
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_VOLUMES_EDIT,
          element: <CorporateClientsVolumesForm />,
        },
      ],
    },
    {
      path: ROUTES.CORPORATE_CLIENTS_RISK_PRODUCTS,
      element: <CorporateClientsProductsList />,
      children: [
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_PRODUCTS_CREATE,
          element: <CorporateClientsProductsForm />,
        },
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_PRODUCTS_EDIT,
          element: <CorporateClientsProductsForm />,
        },
      ],
    },
    {
      path: ROUTES.CORPORATE_CLIENTS_RISK_DELIVERY_CHANNELS,
      element: <CorporateDeliveryChannelsList />,
      children: [
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_DELIVERY_CHANNELS_CREATE,
          element: <CorporateDeliverychannelsForm />,
        },
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_DELIVERY_CHANNELS_EDIT,
          element: <CorporateDeliverychannelsForm />,
        },
      ],
    },
    {
      path: ROUTES.CORPORATE_CLIENTS_RISK_DATE_OF_INCORPORATION,
      element: <CorporateClientsIncorporateDatesList />,
      children: [
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_DATE_OF_INCORPORATION_CREATE,
          element: <CorporateClientsIncorporateDatesForm />,
        },
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_DATE_OF_INCORPORATION_EDIT,
          element: <CorporateClientsIncorporateDatesForm />,
        },
      ],
    },
    {
      path: ROUTES.CORPORATE_CLIENTS_RISK_SIC_CODES,
      element: <CorporateClientsSicCodes />,
      children: [
        {
          path: ROUTES.CORPORATE_CLIENTS_RISK_SIC_CODE,
          element: <CorporateSicCodePanel />,
        },
      ],
    },
  ],
};

export default CorporateClientsRiskRoutes;
